import React, { FC, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";
import moment from "moment";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { PeriodIndexTypes, PeriodTypesArray } from "../../services/enums";
import HighChartsService from "../../services/highcharts.service";
import { IResultResponse } from "../../models/response/result.model";
import ChartRangeSelector from "../CI10/ChartRangeSelector";
import { IMarketDominanceItem } from "../../models/fearAndGreed/marketDominance.model";

const MarketDominanceChart: FC = () => {
  const [periodIndex, setPeriodIndex] = useState(PeriodIndexTypes["1m"]);

  const { fetchedData, loading } = useHttpGet<IResultResponse<IMarketDominanceItem[]>>(
    `${APIRoutes.FEAR_AND_GREED}/marketDominance/${PeriodTypesArray[periodIndex]}`,
    { dependencies: [periodIndex] }
  );

  const getOptions = (data: IMarketDominanceItem = {} as IMarketDominanceItem) => {
    return {
      ...HighChartsService.baseSettings({
        series: [
          {
            name: 'Market Dominance',
            data:
              CommonService.sortByDate(fetchedData?.result)?.map(
                (el: IMarketDominanceItem) => [moment(el?.date).unix() * 1000, el?.dominance]
              ) || [],
          },
        ],
      }),
    };
  };

  return (
    <Spin spinning={loading}>
      <ChartRangeSelector
        show1Day={false}
        periodIndex={periodIndex}
        setPeriodIndex={setPeriodIndex}
      />
      <HighchartsReact
        constructorType={"stockChart"}
        highcharts={Highcharts}
        options={getOptions()}
      />
    </Spin>
  );
};

export default MarketDominanceChart;
